// API Endpoint
const API = "https://api.scryfall.com";
let products = JSON.parse(sessionStorage.getItem("collectionProducts"));
sessionStorage.removeItem("collectionProducts");

// TEMP
// 1. Selecting DOM elements
// const suggestedContainer = document.querySelector(".suggested-products");
// const suggestedBtnsContainer = suggestedContainer.querySelector(
//   ".suggested-products--collections-btns"
// );
// const suggestedBtns = [...suggestedBtnsContainer.querySelectorAll("button")];
// const suggestedProductsContainer = [
//   ...suggestedContainer.querySelectorAll(".suggested-products--list"),
// ];

// 2. Adding the active class to the first button and the first products list
// suggestedBtns.at(0).classList.add("suggested-products--btn-active");
// suggestedProductsContainer.at(0).classList.remove("hidden");

// 3. Display products list based on the clicked button
// suggestedBtnsContainer.addEventListener("click", function (e) {
//   if (
//     !e.target.closest(".suggested-products--btn") ||
//     e.target
//       .closest(".suggested-products--btn")
//       .classList.contains("suggested-products--btn-active")
//   )
//     return;

//   // A. selecting the clicked btn
//   const targetBtn = e.target.closest(".suggested-products--btn");

//   // B. getting the index of the clicked btn
//   const index = +targetBtn.dataset.index;

//   // C. add the active class to the clicked btn and remove it from the others
//   suggestedBtns.forEach((btn) =>
//     btn.classList.remove("suggested-products--btn-active")
//   );
//   targetBtn.classList.add("suggested-products--btn-active");

//   // D. show the products list of the clicked btn and hide the others
//   suggestedProductsContainer.forEach((c) => c.classList.add("hidden"));
//   suggestedProductsContainer.at(index - 1).classList.remove("hidden");
// });

// --- Selecting DOM Elements --- //
const searchForm = document.querySelector(".search__box-form");
const searchInput = searchForm.querySelector("input");
const contentContainer = document.querySelector(".page__content");
const allSetsBtn = document.querySelector(".search__sets");
const searchByArtistBtn = document.querySelector(".search__artist");
const searchByCardBtn = document.querySelector(".search__card");
const advancedBtn = document.querySelector(".search__advanced");
const closeAdvancedSearchBtn = document.querySelector(".close-advanced-search");
const advancedSearchContainer = document.querySelector(
  ".search__options--advanced"
).parentElement;
const colorOptions = [
  ...document.querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("input"));
const colorOptionsLabel = [
  ...document.querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("label"));

// Default search is by card -- initial value
sessionStorage.setItem("search type", "card");

// --- Functions --- //
const cleanUI = function () {
  contentContainer.innerHTML = "";
};

const updateInput = function (type) {
  // Cleaning the UI and search value
  cleanUI();
  searchInput.value = "";

  // Change the search by card value
  sessionStorage.setItem("search type", type);

  // Change the input placeholder
  searchInput.placeholder = `Search for MAGIC: THE GATHERING CARDS ${
    type === "card" ? "" : "BY ARTIST NAME"
  }`;
};

const toggleSearchAdanvaced = function (mode) {
  // show mode
  if (mode === "show") {
    // 1. highlight the button by adding an active class
    advancedBtn.classList.add("search__advanced-active");

    // 2. show the advanced search container
    advancedSearchContainer.classList.remove("hidden");
  } else {
    // hide mode
    // 1. highlight the button by adding an active class
    advancedBtn.classList.remove("search__advanced-active");

    // 2. show the advanced search container
    advancedSearchContainer.classList.add("hidden");
  }
};

const unselectAllAdvancedSearchFilters = function () {
  colorOptions.forEach((option, i) => {
    option.checked = false;
    const currentOptionLabel = colorOptionsLabel.at(i);

    currentOptionLabel.classList.remove("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.add("hidden");
  });
};

const toggleColorOption = function (mode, index) {
  const currentOptionLabel = colorOptionsLabel.at(index);

  if (mode === "active") {
    currentOptionLabel.classList.add("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.remove("hidden");
  } else {
    currentOptionLabel.classList.remove("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.add("hidden");
  }
};

const toggleLastColorOption = function (mode) {
  const lastOptionLabel = colorOptionsLabel.at(-1);

  if (mode === "active") {
    lastOptionLabel.classList.add("advanced-option-active");
    lastOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.remove("hidden");
  } else {
    lastOptionLabel.classList.remove("advanced-option-active");
    lastOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.add("hidden");
  }
};

const renderLoadingSpinner = function () {
  // Cleaning the UI
  cleanUI();

  const markup = `
    <div class="loading-spinner">
      <span></span>
    </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

const renderRelatedProducts = function (cardName, artistName) {
  const markup = `
  <div class='page__content--related'>
    <div class="magic__related-products--btns-container search__options">
      <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
      <button class="magic__related-products--artist" data-artist="${artistName}">Show products related to this artist</button>
    </div>

    <div class="cards magic__related-products--container"></div>
  </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

const renderRelatedProductByCardName = function (cardName, artistName, search) {
  let filteredProductsByCardName;

  if (search) {
    const searchInputValue = searchInput.value
      .trim()
      .toLowerCase()
      .replaceAll("'", "’")
      .replaceAll(",", ",");
    filteredProductsByCardName = products
      .filter(
        (product) =>
          product.title.toLowerCase().includes(cardName.toLowerCase()) ||
          product.title.toLowerCase().includes(searchInputValue)
      )
      .reverse();
  } else {
    filteredProductsByCardName = products
      .filter((product) =>
        product.title.toLowerCase().includes(cardName.toLowerCase())
      )
      .reverse();
  }

  if (!filteredProductsByCardName.length) {
    const markup = `
      <div class='page__content--related'>
        <div class="magic__related-products--btns-container search__options">
          <button class="magic__related-products--card" data-card="${cardName}">Hide products related to this card</button>
          <button class="magic__related-products--artist" data-artist="${artistName}">Show products related to this artist</button>
        </div>

        <div class="magic__related-products--container">
          <p style="text-align: center;">We're sorry, but we couldn't find any products associated with this card.</p>
        </div>
      </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  } else {
    const markup = `
    <div class='page__content--related'>
      <div class="magic__related-products--btns-container search__options">
        <button class="magic__related-products--card" data-card="${cardName}">Hide products related to this card</button>
        <button class="magic__related-products--artist" data-artist="${artistName}">Show products related to this artist</button>
      </div>

      <div class="magic__related-products--container">
        <ul class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8" role="list">
          ${filteredProductsByCardName
            .map(
              (product) => `
            <li>
              <div class="magic__related-product card card--product h-full card--product-contained relative flex">

                <!-- WHISHLIST -->

                <!-- MEDIA -->
                <div class="card__media ${
                  product.media.length > 1 ? "has-hover-image" : ""
                } relative">
                  <a href="/products/${product.handle}" aria-label="${
                product.title
              }" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
                    <img src="${
                      product.media?.at(0).src
                    }&width=460" loading="lazy" class="img-fit card__main-image" width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                    <img src="${
                      product.media?.at(1)?.src
                    }&width=460" loading="lazy" class="img-fit card__hover-image width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                  </a>
                </div>

                <!-- CONTENT -->
                <div class="card__info-container flex flex-col flex-auto relative">
                  <div class="card__info w-full">
                    <div class="card__info-inner inline-block w-full">
                      <p class="card__title font-bold mb-1">
                        <a href="/products/${
                          product.handle
                        }" class="card-link text-current js-prod-link">${
                product.title
              }</a>
                      </p>

                      <!--
                      <div class="price">
                        <div class="price__default">
                          <strong class="price__current">€${new Intl.NumberFormat(
                            "fr-BE"
                          ).format(product.variants?.at(0).price)} EUR</strong>
                        </div>
                      </div> 
                      -->
                    </div>
                  </div>

                  <!-- VIEW PRODUCT -->
                  <div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below">
                    <a class="btn btn--primary w-full" href="/products/${
                      product.handle
                    }">
                      <span class="quick-add-btn-text">View product</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          `
            )
            .join("")}
        </ul>
      </div>
    </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  }
};

const renderRelatedProductByArtistName = function (cardName, artistName) {
  // const filteredProductsByArtistName = products.filter((product) =>
  //   product.tags.toLowerCase().includes(`artist_${artistName.toLowerCase()}`)
  // );

  const filteredProductsByArtistName = products.filter((product) => {
    const productTags = product.tags.map(tag => tag.toLowerCase());
    return productTags.includes(`artist_${artistName.toLowerCase()}`);
  });

  const firstProduct = products.at(0);
  firstProduct.tags.forEach(tag => tag.toLowerCase());

  if (!filteredProductsByArtistName.length) {
    const markup = `
      <div class='page__content--related'>
        <div class="magic__related-products--btns-container search__options">
          <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
          <button class="magic__related-products--artist" data-artist="${artistName}">Hide products related to this artist</button>
        </div>

        <div class="magic__related-products--container">
          <p style="text-align: center;">We're sorry, but we couldn't find any products associated with this artist.</p>
        </div>
      </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  } else {
    const markup = `
    <div class='page__content--related'>
      <div class="magic__related-products--btns-container search__options">
        <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
        <button class="magic__related-products--artist" data-artist="${artistName}">Hide products related to this artist</button>
      </div>

      <div class="magic__related-products--container">
        <ul class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8" role="list">
          ${filteredProductsByArtistName
            .map(
              (product) => `
            <li>
              <div class="magic__related-product card card--product h-full card--product-contained relative flex">

                <!-- WHISHLIST -->

                <!-- MEDIA -->
                <div class="card__media ${
                  product.media.length > 1 ? "has-hover-image" : ""
                } relative">
                  <a href="/products/${product.handle}" aria-label="${
                product.title
              }" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
                    <img src="${
                      product.media?.at(0).src
                    }&width=460" loading="lazy" class="img-fit card__main-image" width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                    <img src="${
                      product.media?.at(1)?.src
                    }&width=460" loading="lazy" class="img-fit card__hover-image width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                  </a>
                </div>

                <!-- CONTENT -->
                <div class="card__info-container flex flex-col flex-auto relative">
                  <div class="card__info w-full">
                    <div class="card__info-inner inline-block w-full">
                      <p class="card__title font-bold mb-1">
                        <a href="/products/${
                          product.handle
                        }" class="card-link text-current js-prod-link">${
                product.title
              }</a>
                      </p>

                      <!--
                      <div class="price">
                        <div class="price__default">
                          <strong class="price__current">€${new Intl.NumberFormat(
                            "fr-BE"
                          ).format(product?.variants?.at(0).price)} EUR</strong>
                        </div>
                      </div>
                      -->
                    </div>
                  </div>

                  <!-- VIEW PRODUCT -->
                  <div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below">
                    <a class="btn btn--primary w-full" href="/products/${
                      product.handle
                    }">
                      <span class="quick-add-btn-text">View product</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          `
            )
            .join("")}
        </ul>
      </div>
    </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  }
};

const renderCards = function (data) {
  const { data: cards, total_cards } = data;

  // Store cards array
  sessionStorage.setItem("cards", JSON.stringify(cards));

  // Cleaning the UI
  cleanUI();

  const markup = `
      <p style="color: #ffffffe0; margin-bottom: 3rem; text-align: center;">
        Total cards: ${total_cards}
      </p>

    <div class='cards'>
      ${cards
        .map((card) =>
          card.image_uris
            ? `<img class='cards__img' src='${card.image_uris?.normal}' alt='${card.name}' data-card-id='${card.id}' loading='lazy' />`
            : ""
        )
        .join("")}
    </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

const renderCard = function (card, setInfo) {
  // Cleaning the UI
  cleanUI();

  // Show suggested products
  // suggestedContainer.classList.remove("hidden");

  const symbols = card.mana_cost
    .split("}")
    .slice(0, -1)
    .map((symbol) => `${symbol}}`);
  const allSymbols = JSON.parse(localStorage.getItem("symbols"));
  const cardSymbols = allSymbols.filter((symbol) =>
    symbols.includes(symbol.symbol)
  );

  const finishes =
    card.foil && card.nonfoil
      ? `Nonfoil/Foil`
      : `${card.foil ? "Foil" : "Nonfoil"}`;

  const correctedRarity = `${card.rarity
    .at(0)
    .toUpperCase()}${card.rarity.slice(1)}`;
  const correctedFinishes = card.finishes.map(
    (finish) => `${finish.at(0).toUpperCase()}${finish.slice(1)}`
  );
  const languageName = new Intl.DisplayNames(["en"], {
    type: "language",
  });

  const markup = `
      <p style="color: #ffffffe0; max-width: 100rem; margin-inline: auto; margin-bottom: 3rem; text-align: center;" class="magic-card__rotate-message">
        NOTE: 🔍 Unlock the secrets of each card! 🃏 Click on the "Flip it" button to reveal its hidden legalities and unleash your strategic prowess! 🌟 Click on the set box to uncover related cards or dive into the world of your favorite artist by clicking on their name. Happy discovering! ✨
      </p>
      <p style="color: #ffffffe0; margin-bottom: 3rem; text-align: center;" class="magic-card__message">
        NOTE: 🌟 Click on the set box to uncover related cards or dive into the world of your favorite artist by clicking on their name. Happy discovering! ✨
      </p>

      <div class="magic-card">
        <img
          src="${card.image_uris.large}"
          alt="${card.name}"
          loading="lazy"
        >

        <div class="magic-card__container--rotate">
          <div class="magic-card__prints magic-card__prints--rotate">
            <div class="magic-card__set">
              <object type="image/svg+xml" data="${setInfo.icon_svg_uri}">
                Your browser does not support SVG
              </object>
              <div class='magic-card__set-info' data-set='${card.set}'>
                <!-- Set name (set) -->
                <p role="h4">
                  <span class="sub-title">&mdash; Release name</span>
                  ${card.set_name} (${card.set.toUpperCase()})
                </p>
                <!-- #collection_number / rarity / lang / finishes -->
                <p>#${
                  card.collector_number
                } &middot; ${correctedRarity} &middot; ${languageName.of(
    card.lang
  )} &middot; ${correctedFinishes.join("/")}</p>
              </div>
            </div>
            <div class="magic-card__info">
              <!-- Name -->
              <div class="magic-card__card-title--container">
                <span class="sub-title">&mdash; Card name</span>
                <p role="h4" class="magic-card__card-title">
                  ${card.name}
                  <span class="magic-card__card-symbol">
                    ${cardSymbols
                      .map((symbol) => {
                        return `
                          <object type="image/svg+xml" data="${symbol.svg_uri}">
                            Your browser does not support SVG
                          </object>
                          `;
                      })
                      .join("")}
                  </span>
                </p>
              </div>
              <!-- Type_line -->
              <p role="h4">
                <span class="sub-title">&mdash; Card category</span>
                ${card.type_line}
              </p>
              <!-- Oracle_text -->
              <p role="h4">
                <span class="sub-title">&mdash; Card description</span>
                ${card.oracle_text}
              </p>
              <!-- Watermark -->
              ${
                card.watermark
                  ? `
                <p role="h4">
                  <span class="sub-title">&mdash; Watermark</span>
                  <span class="magic-card__watermark">${card.watermark.replace(
                    card.watermark.at(0),
                    card.watermark.at(0).toUpperCase()
                  )}</span>
                </p>
              `
                  : ""
              }
              <!-- Artist -->
              <p role="h4" class="last">
                <span class="sub-title">&mdash; Illustrated by</span>
                <span class="magic-card__link magic-card__artist">${
                  card.artist
                }</span>
              </p>

              <!-- Btn to rotate -->
              <button class="magic-card__btn-rotate magic-card__rotate-to-back">
                <span>Flip it</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"></path></svg> 
              </button>
            </div>
          </div>
          <div class="magic-card__legalities-container magic-card__legalities-container--rotate">
            <p class="magic-card__legalities--title">&mdash; Legalities</p>
            <div class="magic-card__legalities">
              <div class="magic-card__legalities-box">
                ${Object.entries(card.legalities)
                  .map((legality) => {
                    const [key, value] = legality;
                    return `
                    <p>
                    <span class="${value.replace("_", "-")}">${value.replace(
                      "_",
                      "-"
                    )}</span>
                    ${key}
                    </p>
                  `;
                  })
                  .join("")}
              </div>
            </div>

            <!-- Btn to rotate -->
              <button class="magic-card__btn-rotate magic-card__rotate-to-front">
                <span>Flip it</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"></path></svg> 
              </button>
          </div>
        </div>

        <div class="magic-card__prints magic-card__mobile-view">
          <div class="magic-card__set">
            <object type="image/svg+xml" data="${setInfo.icon_svg_uri}">
              Your browser does not support SVG
            </object>
            <div class='magic-card__set-info' data-set='${card.set}'>
              <!-- Set name (set) -->
              <p role="h4">
                <span class="sub-title">&mdash; Release name</span>
                ${card.set_name} (${card.set.toUpperCase()})
              </p>
              <!-- #collection_number / rarity / lang / finishes -->
              <p>#${
                card.collector_number
              } &middot; ${correctedRarity} &middot; ${languageName.of(
    card.lang
  )} &middot; ${correctedFinishes.join("/")}</p>
            </div>
          </div>
          <div class="magic-card__info">
            <!-- Name -->
            <div class="magic-card__card-title--container">
              <span class="sub-title">&mdash; Card name</span>
              <p role="h4" class="magic-card__card-title">
                ${card.name}
                <span class="magic-card__card-symbol">
                  ${cardSymbols
                    .map((symbol) => {
                      return `
                        <object type="image/svg+xml" data="${symbol.svg_uri}">
                          Your browser does not support SVG
                        </object>
                        `;
                    })
                    .join("")}
                </span>
              </p>
            </div>
            <!-- Type_line -->
            <p role="h4">
              <span class="sub-title">&mdash; Card category</span>
              ${card.type_line}
            </p>
            <!-- Oracle_text -->
            <p role="h4">
              <span class="sub-title">&mdash; Card description</span>
              ${card.oracle_text}
            </p>
            <!-- Watermark -->
            ${
              card.watermark
                ? `
              <p role="h4">
                <span class="sub-title">&mdash; Watermark</span>
                <span class="magic-card__watermark">${card.watermark.replace(
                  card.watermark.at(0),
                  card.watermark.at(0).toUpperCase()
                )}</span>
              </p>
            `
                : ""
            }
            <!-- Artist -->
            <p role="h4" class="last">
              <span class="sub-title">&mdash; Illustrated by</span>
              <span class="magic-card__link magic-card__artist">${
                card.artist
              }</span>
            </p>
          </div>
        </div>
        <div class="magic-card__legalities-container magic-card__mobile-view">
          <p class="magic-card__legalities--title">&mdash; Legalities</p>
          <div class="magic-card__legalities">
            <div class="magic-card__legalities-box">
              ${Object.entries(card.legalities)
                .map((legality) => {
                  const [key, value] = legality;
                  return `
                  <p>
                  <span class="${value.replace("_", "-")}">${value.replace(
                    "_",
                    "-"
                  )}</span>
                  ${key}
                  </p>
                `;
                })
                .join("")}
            </div>
          </div>
        </div>
      </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);

  // Render products
  renderRelatedProducts(card.name, card.artist);
};

const renderSets = function (sets) {
  // Cleaning the UI
  cleanUI();

  sessionStorage.setItem("all-sets", JSON.stringify(sets));

  const markup = `
    <div class="sets">
      <div role="table">
        <div role="thead">
          <div role="tr">
            <p role="th">Name</p>
            <p role="th">Cards</p>
            <p role="th">Date</p>
          </div>
        </div>
        <div role="tbody">
          ${sets
            .map(
              (set) => `
            <div role="tr" class="sets__set-container" data-set="${set.code}">
              <p role="td" class="sets__set-name-container">
                <span class="sets__set-svg">
                  <!-- <object
                    type="image/svg+xml"
                    data="${set.icon_svg_uri}"
                  >
                    Your browser does not support SVG
                  </object> -->
                  <img src="${set.icon_svg_uri}" alt="Icon of ${set.name}" />
                </span>
                <span class="sets__set-name">${set.name}</span>
                <span class="sets__set-code">${set.code.toUpperCase()}</span>
              </p>
              <p role="td">${set.card_count}</p>
              <p role="td">${set.released_at}</p>
            </div>
          `
            )
            .join("")}
        </div>
      </div>
    </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

// const fetchingRelatedProducts = async function (cardName, artistName) {
//   const loadingMarkup = `
//     <div class="loading-spinner">
//       <span></span>
//     </div>
//   `;

//   const buttonsMarkup = `
//     <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
//     <button class="magic__related-products--artist" data-artist="${artistName}">Show products related to this artist</button>
//   `;

//   const container = contentContainer.querySelector(
//     ".magic__related-products--btns-container"
//   );

//   try {
//     // In case we will not fetch the products every single time we select the card
//     if (products.length) return products;

//     // Render loading spinner
//     container.innerHTML = loadingMarkup;

//     // Fetch related products
//     const res = await fetch("https://upi-euro.onrender.com/api/products");
//     // const res = await fetch('http://localhost:3000/api/products');
//     if (!res.ok)
//       throw new Error(
//         "An error occurred while fetching related products to this card"
//       );

//     const data = await res.json();
//     products = data;

//     // Render buttons
//     container.innerHTML = buttonsMarkup;
//   } catch (error) {
//     console.log(error.message);
//     container.innerHTML = error.message;
//   }
// };

const fetchingCards = async function (cardName) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards/search?q=${cardName}`);
    if (!res.ok) throw new Error("Card not found. Please try again!");

    const data = await res.json(); // data it's an array containing card data

    if (data) {
      // render cards to UI
      renderCards(data);
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();

    // Print the error message to the UI
    const markup = `
      <p style="text-align: center;">${error.message}</p>
    `;

    contentContainer.insertAdjacentHTML("beforeend", markup);
  }
};

const fetchingSets = async function () {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/sets`);
    if (!res.ok) throw new Error("Card not found. Please try again!");

    const { data } = await res.json();

    if (data) {
      // Avoid page block because of this heavy data
      // localStorage.setItem('all-sets', JSON.stringify(data));
      // render cards to UI
      renderSets(data);
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();
  }
};

const fetchingSetCards = async function (setCode) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards/search?q=set:${setCode}`);
    if (!res.ok) throw new Error("Set Cards not found. Please try again!");

    const data = await res.json(); // data it's an array containing card data

    if (data) {
      // render cards to UI
      renderCards(data);
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();
  }
};

const fetchingArtistCards = async function (artist) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards/search?q=a:“${artist}”`);
    if (!res.ok) throw new Error("Artist Cards not found. Please try again!");

    const data = await res.json(); // data it's an array containing card data

    if (data) {
      // render cards to UI
      renderCards(data);
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();

    // Print the error message to the UI
    const markup = `
      <p style="text-align: center;">${error.message}</p>
    `;

    contentContainer.insertAdjacentHTML("beforeend", markup);
  }
};

const fetchingSetInfo = async function (setId) {
  try {
    const res = await fetch(`${API}/sets/${setId}`);
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

const fetchingSymbols = async function () {
  try {
    const res = await fetch(`${API}/symbology`);
    if (!res.ok) throw new Error(res.status);

    const { data } = await res.json();
    localStorage.setItem("symbols", JSON.stringify(data));
  } catch (error) {
    console.log(error.message);
  }
};
localStorage.getItem("symbols") || fetchingSymbols();

// --- Event handlers --- //
// Searching for cards event
searchForm.addEventListener("submit", function (e) {
  e.preventDefault();

  // Hide suggested products
  // suggestedContainer.classList.add("hidden");

  // Searching...
  let correctedValue;
  const searchType = sessionStorage.getItem("search type");

  // In cas the user didn't enter any value
  if (
    (!searchInput.value && searchType === "artist") ||
    (searchType === "card" &&
      !searchInput.value &&
      !advancedBtn.classList.contains("search__advanced-active"))
  )
    return;

  // search by card
  if (searchType === "card") {
    // Check if the advanced search is selected -- if TRUE adjust the search input value
    if (advancedBtn.classList.contains("search__advanced-active")) {
      const searchInputValue = searchInput.value
        .toLowerCase()
        .replaceAll(" ", "+");

      // 1. selecting the color checkboxes
      const checkedColorOptions = colorOptions.filter(
        (option) => option.checked
      );

      // 2. check if the length is > 0 -- There're a selected options
      if (!searchInput.value && !checkedColorOptions.length) return;

      //   if (checkedColorOptions.length > 0) {
      const checkedOptionsValues = checkedColorOptions
        .map((option) => option.value)
        .join("");
      correctedValue = `${searchInputValue}+color=${checkedOptionsValues}`;
      //   } else {
      // correctedValue = searchInputValue;
      //   }
    }
    // If NOT don't adjust the search input value
    else {
      correctedValue = searchInput.value.toLowerCase().replaceAll(" ", "+");
    }

    fetchingCards(correctedValue);
  }
  // search by artist
  if (searchType === "artist") fetchingArtistCards(correctedValue);
});

// Selecting card event
contentContainer.addEventListener("click", async function (e) {
  // 1. selecting DOM elements
  const cardsEl = contentContainer.querySelector(".cards");
  if (!cardsEl || !e.target.closest(".cards__img")) return;

  const cards = JSON.parse(sessionStorage.getItem("cards"));
  const card = cards.find((card) => card.id === e.target.dataset.cardId); // We are storing the card id on the image

  // 2. fetching the card set info
  const setInfo = await fetchingSetInfo(card.set_id);

  // 3. render the card
  renderCard(card, setInfo);

  // 4. fetch related products
  // await fetchingRelatedProducts(card.name, card.artist);
  // renderRelatedProducts(card.name, card.artist);

  // 5. Handle click related buttons
  sessionStorage.setItem("related-type", "none");
});

// Handle click on the card set
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".magic-card__set-info")) return;

  const setCode = e.target.closest(".magic-card__set-info").dataset.set;
  fetchingSetCards(setCode);
});

// Handle click on the card artist
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".magic-card__artist")) return;

  const artist = e.target.textContent.replaceAll(" ", "+");
  fetchingArtistCards(artist);
});

// Handle click on all sets buttons
allSetsBtn.addEventListener("click", function () {
  // Clean the input
  searchInput.value = "";

  // Hide suggested products
  // suggestedContainer.classList.add("hidden");

  // 1. hide and disable the advanced the advanced search
  advancedBtn.disabled = true;
  toggleSearchAdanvaced("hide");

  // 2. disable all the filters
  unselectAllAdvancedSearchFilters();

  // Avoid page block because of this heavy data
  sessionStorage.getItem("all-sets")
    ? renderSets(JSON.parse(sessionStorage.getItem("all-sets")))
    : fetchingSets();
  // fetchingSets();
});

// Handle click on the advanced search button
advancedBtn.addEventListener("click", function () {
  // Show
  if (!this.classList.contains("search__advanced-active"))
    toggleSearchAdanvaced("show");
  // Hide
  else if (this.classList.contains("search__advanced-active")) {
    // 1. hide the advanced search
    toggleSearchAdanvaced("hide");

    // 2. disable all the filters
    unselectAllAdvancedSearchFilters();
  }
});

// Handle click on the close advanced search container button
closeAdvancedSearchBtn.addEventListener("click", function () {
  // 1. hide the advanced search
  toggleSearchAdanvaced("hide");

  // 2. disable all the filters
  unselectAllAdvancedSearchFilters();
});

// Handle click on the advanced search color options
// (LAST OPTION) -- disable all the color checkboxes when the COLORLESS option is selected
colorOptions.at(-1).addEventListener("change", function () {
  if (this.checked) {
    // 1. disable all the filters
    unselectAllAdvancedSearchFilters();

    // check only the last option
    this.checked = true;

    // highlight the label
    toggleLastColorOption("active");
  }
});

// (REST OPTIONS) -- disable only the last option (COLORLESS) option
// removing the last option from the array
colorOptions.slice(0, -1).forEach((option, i) => {
  option.addEventListener("change", function () {
    if (this.checked) {
      // highlight the label
      toggleColorOption("active", i);

      // disable the last option
      colorOptions.at(-1).checked = false;
      toggleLastColorOption("disable");
    } else {
      // disable the label
      toggleColorOption("disable", i);
    }
  });
});

// Handle click on set box
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".sets__set-container")) return;

  const setCode = e.target.closest(".sets__set-container").dataset.set;
  fetchingSetCards(setCode);
});

// Handle click on artist button
searchByArtistBtn.addEventListener("click", function () {
  updateInput("artist");

  // Show suggested products
  // suggestedContainer.classList.remove("hidden");

  // 1. hide and disable the advanced the advanced search
  advancedBtn.disabled = true;
  toggleSearchAdanvaced("hide");

  // 2. disable all the filters
  unselectAllAdvancedSearchFilters();
});

// Handle click on card button
searchByCardBtn.addEventListener("click", function () {
  updateInput("card");

  // Show suggested products
  // suggestedContainer.classList.remove("hidden");

  // 1. unable the advanced search feature
  advancedBtn.disabled = false;
});

// Handle click on show related products by card name
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".magic__related-products--card")) return;

  // 1. Selecting the btn element
  const target = e.target.closest(".magic__related-products--card");
  const container = contentContainer.querySelector(
    ".magic__related-products--container"
  );

  // 2. Changing the value of the related click type
  sessionStorage.setItem("related-type", "card");

  // 2. Clean the container
  container.innerHTML = "";

  // 3. Render related products
  const artistName = target.nextElementSibling.dataset.artist;
  renderRelatedProductByCardName(
    target.dataset.card,
    artistName,
    searchInput.value !== "" ? true : false
  );
});

// Handle click on show related products by artist name
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".magic__related-products--artist")) return;

  // 1. Selecting the btn element
  const target = e.target.closest(".magic__related-products--artist");
  const container = contentContainer.querySelector(
    ".magic__related-products--container"
  );

  // 2. Changing the value of the related click type
  sessionStorage.setItem("related-type", "artist");

  // 3. Clean the container
  container.innerHTML = "";

  // 4. Render related products
  const cardName = target.previousElementSibling.dataset.card;
  renderRelatedProductByArtistName(cardName, target.dataset.artist);
});

// Handle click on rotate magic card (FLIP IT)
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".magic-card__btn-rotate")) return;

  const container = contentContainer.querySelector(
    ".magic-card__container--rotate"
  );

  // 1. Selecting the btn element
  const target = e.target.closest(".magic-card__btn-rotate");

  // 2. Check if the card is flipped
  if (target.classList.contains("magic-card__rotate-to-front")) {
    // Remove the flipped class
    container.classList.remove("magic-card__rotated");
  } else {
    // Add the flipped class
    container.classList.add("magic-card__rotated");
  }
});
